import { formatBRShort } from './format'

type Bands = {
  lower?: number
  median?: number
  upper?: number
  shaded?: { from: number; to: number; opacity?: number; color?: string }
}

type BandOpts = {
  nudgeLabels?: boolean // desloca rótulos para evitar sobreposição
  xPaper?: number // posição horizontal das labels em coords do "paper" (0..1)
}

export const buildBandShapes = (bands?: Bands, opts?: BandOpts) => {
  if (!bands) return { shapes: [], annotations: [] as any[] }

  const shapes: any[] = []
  const ann: any[] = []
  const nudge = opts?.nudgeLabels === true

  if (typeof bands.lower === 'number' && typeof bands.upper === 'number') {
    shapes.push({
      type: 'rect',
      xref: 'paper',
      yref: 'y',
      x0: 0,
      x1: 1,
      y0: Math.min(bands.lower, bands.upper),
      y1: Math.max(bands.lower, bands.upper),
      fillcolor: '#cfd1d4',
      opacity: typeof bands.shaded?.opacity === 'number' ? bands.shaded.opacity : 0.28,
      line: { width: 0 },
    })
  }

  const addHLine = (y: number, style: 'solid' | 'dot', color: string, width = 2) =>
    shapes.push({
      type: 'line',
      xref: 'paper',
      yref: 'y',
      x0: 0,
      x1: 1,
      y0: y,
      y1: y,
      line: { dash: style, color, width },
    })

  // Deslocamentos verticais quando comprimido
  const yshiftUpper = nudge ? +12 : 0
  const yshiftMedian = nudge ? 0 : 0
  const yshiftLower = nudge ? -12 : 0

  const addAnn = (y: number, label: string, yshift = 0) =>
    ann.push({
      xref: 'paper',
      yref: 'y',
      x: 1.01,
      y,
      xanchor: 'left',
      yanchor: 'middle',
      showarrow: false,
      font: { size: 12, color: '#000', family: 'Figtree, sans-serif' },
      text: label,
      align: 'left',
      yshift,
      bgcolor: 'white',
      bordercolor: 'rgba(0,0,0,0)',
      borderpad: 1,
    })

  if (typeof bands.upper === 'number') {
    addHLine(bands.upper, 'dot', '#9ca3af')
    addAnn(bands.upper, formatBRShort(bands.upper), yshiftUpper)
  }
  if (typeof bands.median === 'number') {
    addHLine(bands.median, 'solid', '#4b5563', 3)
    addAnn(bands.median, formatBRShort(bands.median), yshiftMedian)
  }
  if (typeof bands.lower === 'number') {
    addHLine(bands.lower, 'dot', '#9ca3af')
    addAnn(bands.lower, formatBRShort(bands.lower), yshiftLower)
  }

  return { shapes, annotations: ann }
}
